//获取当前时间
export const getDateDetail = function (date) {
  if (date && date.getFullYear()) {
    let dateDetail = {};
    dateDetail.year = date.getFullYear();
    dateDetail.month = (date.getMonth() + 1) > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
    dateDetail.day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
    dateDetail.hour = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
    dateDetail.minute = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
    dateDetail.second = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds();

    return dateDetail;
  } else {
    return date;
  }

}
/**
 * @function getDateStr
 * @memberOf pbFunc
 * @ngdoc function
 * @description 返回截取的日期
 * @param  {Number}  AddDayCount [截取前后的天数]
 * @return {date}      [返回截取的日期]
 */
export const getDateStr = function (AddDayCount) {
  var dd = new Date();
  dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
  var y = dd.getFullYear();
  var m =
    dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
  var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
  return y + "-" + m + "-" + d;
}


export const getDateDiff = function (startTime, endTime, diffType) {
  //将xxxx-xx-xx的时间格式，转换为 xxxx/xx/xx的格式 
  startTime = startTime.replace(/\-/g, "/");
  endTime = endTime.replace(/\-/g, "/");

  //将计算间隔类性字符转换为小写
  diffType = diffType.toLowerCase();
  var sTime = new Date(startTime); //开始时间
  var eTime = new Date(endTime); //结束时间
  //作为除数的数字
  var divNum = 1;
  switch (diffType) {
    case "second":
      divNum = 1000;
      break;
    case "minute":
      divNum = 1000 * 60;
      break;
    case "hour":
      divNum = 1000 * 3600;
      break;
    case "day":
      divNum = 1000 * 3600 * 24;
      break;
    default:
      break;
  }
  return parseInt((eTime.getTime() - sTime.getTime()) / parseInt(divNum));
}
/**
 * [dateDiff 算时间差]
 * @param  {[type=Number]} hisTime [历史时间戳，必传]
 * @param  {[type=Number]} nowTime [当前时间戳，不传将获取当前时间戳]
 * @return {[string]}         [string]
 */
export const dateDiff = function (hisTime, nowTime) {
  if (!arguments.length) return '';
  var arg = arguments,
    now = arg[1] ? arg[1] : new Date().getTime(),
    diffValue = now - arg[0],
    result = '',

    minute = 1000 * 60,
    hour = minute * 60,
    day = hour * 24,
    halfamonth = day * 15,
    month = day * 30,
    year = month * 12,

    _year = diffValue / year,
    _month = diffValue / month,
    _week = diffValue / (7 * day),
    _day = diffValue / day,
    _hour = diffValue / hour,
    _min = diffValue / minute;
  if (_year >= 1) result = parseInt(_year) + "年前";
  else if (_month >= 1) result = parseInt(_month) + "个月前";
  else if (_week >= 1) result = parseInt(_week) + "周前";
  else if (_day >= 1) result = parseInt(_day) + "天前";
  else if (_hour >= 1) result = parseInt(_hour) + "个小时前";
  else if (_min >= 1) result = parseInt(_min) + "分钟前";
  else result = "刚刚";
  return result;
}



// WEBPACK FOOTER //
// ./src/assets/js/date.js